import { render, staticRenderFns } from "./VisitSummaryDiagnosis.vue?vue&type=template&id=66484c05&scoped=true&lang=pug&"
import script from "./VisitSummaryDiagnosis.vue?vue&type=script&lang=js&"
export * from "./VisitSummaryDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66484c05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VHover,VIcon})
